module.exports = __webpack_public_path__ + "img/green-energy-2.a0bec632.jpg";